import { AlpineComponent } from '@alpinejs/csp';
import Lottie from 'lottie-web';

const ArticleStage = (): AlpineComponent => ({
  visible: false,
  lottie: undefined,
  placeholderIconLottie: undefined,

  init() {
    const path =
      window.innerWidth < 768
        ? '/assets/animations/arrow-mobile.json'
        : '/assets/animations/arrow-desktop.json';

    this.lottie = Lottie.loadAnimation({
      container: this.$refs.animation,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path,
      rendererSettings: {
        viewBoxOnly: true
      }
    });

    this.lottie.addEventListener('complete', () => {
      this.visible = true;
    });

    if (this.$refs.placeholderIcon) {
      const handle = this.$refs.placeholderIcon.dataset.handle;
      const placeholderPath = `/assets/animations/placeholder-${handle}.json`;

      this.placeholderIconLottie = Lottie.loadAnimation({
        container: this.$refs.placeholderIcon,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: placeholderPath,
        rendererSettings: {
          viewBoxOnly: true
        }
      });

      setTimeout(() => {
        this.placeholderIconLottie.play();
      }, 866);
    }
  },

  handleIntersect() {
    if (this.lottie) {
      this.lottie.play();
    }

    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'article-stage--visible' : '';
  },
  scrollToTarget() {
    const target = document.querySelector(this.$el.dataset.target);
    if (!target) return;

    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY,
      behavior: 'smooth'
    });
  }
});

export default ArticleStage;
